import { html, ref, ViewTemplate } from '@microsoft/fast-element';
import type { SummaryChat } from './summary-chat';

export const SummaryChatTemplate: ViewTemplate<SummaryChat> = html`
  <div class="summary-header">
    <slot name="header"></slot>
  </div>
  <div class="summary-container">
    <div class="summary-description">
      <div>${(x) => x.summaryDescription}</div>
    </div>
    <table class="table">
      <thead>
        <tr>
          <th></th>
          <th class="red-header" width="25%">${(x) => x.productType}</th>
          <th class="blue-header" width="25%">RFQ</th>
        </tr>
      </thead>
      <tbody ${ref('summaryTableBody')}></tbody>
    </table>
    <div class="summary-description text-red">
      <slot name="warning"></slot>
    </div>
  </div>
  <div class="responses">
    <div class="actions">
      <slot name="actions"></slot>
    </div>
  </div>
`;
